
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import { getPackageInfoDetails, editPackageInfo, getPackageType } from "@/api/package";
import { getOtherInfoOne, editOtherInfo, getPackageType } from "@/api/package";
import { getSuppliersList } from "@/api/inquiry";
import { doDownload } from "@/utils/oss-download";

@Component({
  name: "edit"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "编辑" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {} | any;

  @Watch("show", { immediate: true })
  private watchData() {
    if (this.show) {
      // this.getPackageType();
      this.getList();
    }
  }

  private form = {
    customerId: null,
    company: null
  };
  public info = {} as any;
  public infoFields = [
      {
      label: "S/N",
      key: "sn"
    },
    {
      label: "识别号码",
      key: "inquiryRefNumber"
    },
    {
      label: "识别号码类型",
      key: "inquiryRefType"
    },
    {
      label: "华强品名",
      key: "hqProductName"
    },
    {
      label: "供应商简称",
      key: "supplier"
    }
  ] as any;
  public infoFields2 = [
    {
      label: "尼龙袋",
      key: "nylon",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "内盒",
      key: "innerBox",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "外箱",
      key: "outerBox",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "托盘",
      key: "pallet",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "激光—客人商标",
      key: "customerLogo",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "激光—客人供应商代码",
      key: "customerSupplierCode",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "激光—其他信息",
      key: "laserOtherInfo",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "内盒贴标—产品名称",
      key: "productName",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "内盒贴标—OE号码",
      key: "oeNumber",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "内盒贴标—车型",
      key: "carApplication",
      type: "textarea",
      maxlength: 512,
      showWordLimit:true
    },
    {
      label: "内盒贴标—条形码",
      key: "barCode",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "内盒贴标—QR码",
      key: "qrCode",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    },
    {
      label: "内盒贴标—其他信息",
      key: "innerBoxOtherInfo",
      type: "textarea",
      maxlength: 255,
      showWordLimit:true
    }
  ] as any;

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async getList() {
    this.info = await getOtherInfoOne(this.selectedItem.id);
    this.info.supplierId = this.info.supplier || "";
  }

  // private async getSuppliersList(name = "") {
  //   const res: any = await this.getSuppliers(name);
  //   this.infoFields2[2].options = res;
  // }

  // private async getSuppliers(name = "") {
  //   const res: any = await getSuppliersList({ abbreviation: name });
  //   return res;
  // }

  // private async getPackageType() {
  //   const res: any = await getPackageType();
  //   this.infoFields2[1].options = res;
  // }


  private async submitForm(): Promise<void> {
    let params = {
      ...this.info
    };
    try {
      await editOtherInfo(this.selectedItem.id, params);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

}
